<template>
  <div class="index" v-loading="loading">
    <div>
      <div class="content-top">
        <div class="title">
          <span>统计分析</span>
          <div class="head">
            <el-select v-model="form.year" placeholder="请选择年份">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-select v-model="form.company" placeholder="请选择子账号" class="buyrecord">
              <el-option v-for="item in companyList" :key="item.id" :label="item.text" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" class="buyrecord" @click="getList">搜索</el-button>
          </div>
        </div>
        <div class="tabs-body"  style='height:calc(100vh - 167px);overflow:auto'>
          <el-table  ref='tableRef'  :header-cell-style="{background:'rgba(59,196,146,0.1)'}" show-summary  :summary-method="getSummaries" :data="tableData" border style="width: 100%">
            <el-table-column :width="item.prop=='year'||item.prop=='mouth'||item.prop=='total'?'120':''" v-for="(item, index) in desCol" :key="index" :prop="item.prop" 
              :label="item.label"></el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getcompanybyorgId,
  sendRecord,
} from '@/api/setUp.js';

export default {
  name: "index",

  data() {
    return {
      tabHeight:'',
      loading:false,
      options: [ ],
      form: {
        year: "",
        company: "",
      },
      companyList: [],
      tableData: [],
      desCol: [
        { prop: "year", label: "年份" },
        { prop: "mouth", label: "月份" },
        { prop: "total", label: "发送总条数" },
      ]
    };
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (index === 1) {
          sums[index] = ''
          return
        }
        const values = data.map((item) => item[column.property])
        //对表格数据进行循环
        values.map((item) => {
          if (typeof item === 'number' && item !== Infinity && !isNaN(item)) {
            //判断是否为时间戳
            if (item > 160000000000) {
              sums[index] = '-'
              return
            } else {
              //对number数据进行累加
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr)
                if (!isNaN(value)) {
                  //解决js计算小数出现小数点后多位数字的问题
                  return Math.floor((prev + curr) * 100) / 100
                } else {
                  return prev
                }
              }, 0)
            }
          } else {
            //不为number类型则置为--
            sums[index] = '-'
            return
          }
        })
      })
      return sums
    },
    getUserInfo() {
      this.$http.get("authority-center/common/user/info").then(async (res) => {
        this.orgInfo = res.data;
        let { data } = await getcompanybyorgId(res.data.orgId);
        this.companyList = data;
        console.log(this.companyList);
      });
    },

    async getList() {
      this.loading =true
      this.desCol=[
        { prop: "year", label: "年份" },
        { prop: "mouth", label: "月份" },
        { prop: "total", label: "发送总条数" },
      ]
      let { data } = await sendRecord(this.form);
      this.loading =false

      this.tableData = data;

      // 合并子账号
      let child = []
      data.forEach((item) => {
        child = [...child, ...item.count];
      });

      console.log(child, 'ccc')
      // 子账号去重
      let filterChild = [];

      child.forEach(el => {
        if (!filterChild.some(e => e.value == el.value)) {//这里子账号英文名的值
          filterChild.push(el);
        }
      });

      console.log(filterChild, 'filterChild')

      filterChild.forEach((j) => {
        this.desCol.push({ "prop": j.value, "label": j.name })//这里的值取子账号的中文名和英文名
      });

      this.tableData.forEach((k) => {
        k.count.forEach((m) => {
          k[`${m.value}`] = m.number;//这里子账号英文名的值 total 取子账号的数量
        })
      });
      console.log(this.tableData, 'c++++++++++');
      // console.log(,'data--------------',this.desCol)
      this.tabHeight='100%';
      this.$refs.tableRef.doLayout();
    },
    async getYears() {
      this.loadingBtn = true;
      let res = await this.$http.get(`/salary-service/customer/getSendRecordYears`);
      if(res.data.data.length>0){
        this.form.year=res.data.data[0]
        res.data.data.forEach((item) => {
        this.options.push({
          id: item,
          value: item,
          label:item+'年'
        })
      });
      }else{
        let tYear = new Date().getFullYear();
        this.form.year=tYear;
      }
     
    },
  },

  mounted() {
    this.getUserInfo();
    this.getYears();
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.index{
  height: calc(100vh - 61px);
  overflow: hidden;
}
.content-top {
  background: #fff;
  margin: 10px ;
  border-radius: 8px;
  padding: 2vh 14px;
  height:calc(100vh - 81px);
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 15px;

    span {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #2c2d3a;
      line-height: 28px;
    }

    .buyrecord {
      margin-left: 10px;
    }
  }
}
/deep/ .el-table__footer .has-gutter .el-table_1_column_1{
  color:#3BC492;
  font-weight: bold;
}



/deep/ .el-table th.gutter,/deep/ .el-table colgroup col[name='gutter']{
  display: none;
  width:0
}
/deep/ .el-table__body{
  width: 100% !important;
}
/deep/ .el-table .el-table__body-wrapper td.el-table__cell{
  position: relative;
  right:-1px;
}

</style>
